import { Box } from '@mui/material';
import { DataGridPremium as DataGrid } from '@mui/x-data-grid-premium';
import { memo } from 'react';

const IncidentsTable = ({
  rows,
  columns,
  onPaginationModelChange,
  paginationModel,
  rowsCount,
}) => {
  return (
    <Box sx={{ width: '100%' }}>
      <DataGrid
        rows={rows}
        columns={columns}
        disableRowSelectionOnClick
        pageSizeOptions={[10, 20, 50, 100]}
        paginationModel={paginationModel}
        onPaginationModelChange={onPaginationModelChange}
        paginationMode="server"
        rowCount={rowsCount}
        rowHeight={58}
        columnHeaderHeight={46}
        autoHeight
        sx={{
          border: 'none',
          fontFamily: 'karla, sans-serif',
          // Header
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: '#fafafa',
            borderBottom: '2px solid #e8e8e8',
          },
          '& .MuiDataGrid-columnHeader': {
            '&:focus, &:focus-within': { outline: 'none' },
          },
          '& .MuiDataGrid-menuIcon': {
            display: 'none',
          },
          '& .MuiDataGrid-columnHeaderTitle': {
            color: '#555',
            fontWeight: 700,
            fontSize: '0.8rem',
            textTransform: 'uppercase',
            letterSpacing: '0.03em',
          },
          '& .MuiDataGrid-columnSeparator': {
            display: 'flex',
            color: '#ddd',
          },
          '& .MuiDataGrid-columnSeparator--resizable:hover': {
            color: '#BF1D2D',
          },
          // Rows
          '& .MuiDataGrid-row': {
            borderLeft: '3px solid transparent',
            transition: 'background-color 0.15s ease',
            '&:nth-of-type(even)': {
              backgroundColor: '#fbfbfb',
            },
            '&:hover': {
              backgroundColor: '#f0f4ff',
              borderLeft: '3px solid #BF1D2D',
            },
          },
          // Cells
          '& .MuiDataGrid-cell': {
            borderBottom: '1px solid #f0f0f0',
            display: 'flex',
            alignItems: 'center',
            '&:focus, &:focus-within': { outline: 'none' },
          },
          // Hide scrollbar but keep scroll functional
          '& .MuiDataGrid-virtualScroller': {
            scrollbarWidth: 'none',           // Firefox
            '&::-webkit-scrollbar': {         // Chrome, Edge, Safari
              display: 'none',
            },
          },
          // Footer / Pagination
          '& .MuiDataGrid-footerContainer': {
            borderTop: '2px solid #e8e8e8',
            backgroundColor: '#fafafa',
          },
          '& .MuiTablePagination-selectLabel': {
            margin: 0,
            color: '#666',
            fontSize: '0.82rem',
          },
          '& .MuiTablePagination-displayedRows': {
            margin: 0,
            fontSize: '0.82rem',
            color: '#666',
          },
          '& .MuiTablePagination-actions': {
            color: '#555',
          },
        }}
      />
    </Box>
  );
};

export default memo(IncidentsTable);
